/** 设置 -> 规划 -> 管辖边界：文件上传、资源库图层选择、地图预览与信息。 */
export default {
  boundary: '管辖边界',
  boundaryHint:
    '来自 GeoJSON 文件或资源库图层的 WGS 84（EPSG:4326）多边形，GeoJSON 最多 1,000,000 个字符。场地位于其外的图纸将无法通过检查。',
  boundaryUpload: '上传 GeoJSON',
  boundaryRemove: '移除边界',
  boundaryNone: '无边界：检查将提示未配置管辖范围。',
  boundarySummary: '{{type}}，共 {{vertices}} 个顶点',
  boundaryMap: '管辖边界地图',
  boundaryArea: '面积：{{area}} 平方公里',
  boundaryExtent: '范围：经度 {{minLon}} 至 {{maxLon}}，纬度 {{minLat}} 至 {{maxLat}}',
  boundaryWarnings: {
    very_small: '对于管辖范围而言，此面积非常小（小于 0.5 平方公里）。请确认边界是否正确。',
    very_large: '对于管辖范围而言，此面积非常大（超过 50,000 平方公里）。请确认边界是否正确。',
  },
  boundarySource: {
    file: '来自文件 {{name}}',
    layerFeature: '来自图层 {{layer}}，要素 {{feature}}',
    layerAll: '来自图层 {{layer}}，全部要素',
    noId: '此要素没有 ID，因此无法从图层刷新。',
  },
  boundaryRefresh: '从图层刷新',
  boundaryRefreshing: '正在刷新…',
  boundaryRefreshed: '已从图层刷新。请保存以保留更改。',
  boundaryLayer: {
    open: '使用图层中的要素',
    layer: '多边形图层',
    chooseLayer: '选择图层',
    loadingLayers: '正在加载图层…',
    layersFailed: '无法加载资源库图层。',
    noLayers: '资源库中没有可用的多边形图层。',
    layersCapped: '仅搜索了资源库中的前 {{limit}} 个图层。',
    noLayersCapped: '资源库的前 {{limit}} 个图层中没有可用的多边形图层。',
    loadingFeatures: '正在加载要素…',
    featuresFailed: '无法读取此图层。请重试或选择其他图层。',
    noFeatures: '此图层没有多边形要素。',
    labelField: '标签属性',
    feature: '要素',
    chooseFeature: '选择要素',
    allFeatures: '此图层中的全部要素',
    unnamed: '要素 {{n}}',
    featuresCapped: '仅列出前 {{limit}} 个要素，“全部要素”也只合并这些要素。',
    noIdWarning: '此要素没有 ID，因此以后无法从图层刷新。',
    use: '使用此边界',
    cancel: '取消',
  },
  boundaryErrors: {
    too_large: '边界过于详细：GeoJSON 超过 1,000,000 个字符。请选择较小的要素或将其简化。',
    file_too_large: '文件超过 10 MB。',
    invalid_json: '文件不是有效的 JSON。',
    no_polygon: '未找到多边形或多多边形。',
    bad_coordinates: '坐标不是 WGS 84 经纬度。',
    fetch_failed: '无法读取图层。请稍后重试。',
    feature_gone: '该要素已不在图层中（仅搜索前 1,000 个要素）。',
    not_refreshable: '此要素没有 ID，因此无法从图层刷新。',
  },
} as const
